// import "./index.scss";

import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./screens/home/main";
import ClientLayout from "./layouts/clientLayout/clientLayout";
import DashboardLayout from "./layouts/dashboardLayout/dashboardLayout";
import BioData from "./screens/dashboardPages/bioData/main";
import AuthLayout from "./layouts/authLayout.tsx/authLayout";
import { routes } from "./routes";
import { AboutUs, ContactUs, Login, Register, StudentLife } from "./screens";
import WorkHistory from "./screens/dashboardPages/workHistory/main";
import Institute from "./screens/dashboardPages/institute/main";
import Payments from "./screens/dashboardPages/payments/main";
import Qualification from "./screens/dashboardPages/qualification/main";
import UtmeResult from "./screens/dashboardPages/utmeResult/main";
import ViewQualification from "./screens/dashboardPages/qualification/view";
import ViewWorkHistory from "./screens/dashboardPages/workHistory/view";
import ViewInstitute from "./screens/dashboardPages/institute/view";

import Dashboard from "./screens/dashboardPages/dashboard/main";
import CourseDetails from "./screens/courseDetails/main";
import Onboarding from "./screens/onboarding/main";
import LandingPage from "./screens/landingPage/landingPage";
import ProtectedRoute from "./hooks/protectedRoute";
import ForgotPassword from "./screens/forgotPassword/main";
import ResetPassword from "./screens/resetPassword/main";
import RequeryPayment from "./screens/requeryPayment/main";
import { useEffect } from "react";
import VerifyEmail from "./screens/verifyEmail/main";
import PaymentReceipt from "./screens/dashboardPages/payments/receipt";
import ApplicationStatus from "./screens/dashboardPages/applicationStatus/main";
import ApplicationForm from "./screens/dashboardPages/applicationForm/main";
import AdmissionStatus from "./screens/dashboardPages/admissionStatus/main";
import PaymentStatus from "./screens/dashboardPages/payments/PaymentStatus";
import RemitaSummary from "./screens/dashboardPages/payments/RemitaSummary";
import RequiredDocuments from "./screens/dashboardPages/requiredDocuments/main";
import Scholarship from "./screens/dashboardPages/scholarship/main";
import ChangePassword from "./screens/dashboardPages/changePassword/main";
import ReferenceUpload from "./ReferenceUpload";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, [pathname]);

  const authRoute = [
    {
      path: routes.auth.login,
      element: <Login />,
    },
    {
      path: routes.auth.register,
      element: <Register />,
    },
    {
      path: routes.auth.landing,
      element: <LandingPage />,
    },
    {
      path: routes.auth.forgotPassword,
      element: <ForgotPassword />,
    },
    {
      path: routes.auth.resetPassword,
      element: <ResetPassword />,
    },
    {
      path: routes.auth.verifyEmail,
      element: <VerifyEmail />,
    },
    {
      path: routes.auth.requeryPayment,
      element: <RequeryPayment />,
    },
  ];

  const mainRoutes = [
    {
      path: routes.main.contactUs,
      element: <ContactUs />,
    },
    {
      path: routes.main.home,
      element: <Home />,
    },
    {
      path: routes.main.studentLife,
      element: <StudentLife />,
    },
    {
      path: routes.main.courseDetails,
      element: <CourseDetails />,
    },
    {
      path: routes.main.aboutUs,
      element: <AboutUs />,
    },
  ];

  const dashboardRoutes = [
    {
      path: routes.dashboard.bioData,
      element: <BioData />,
    },
    {
      path: routes.dashboard.workHistory,
      element: <WorkHistory />,
    },
    {
      path: routes.dashboard.requiredDocuments,
      element: <RequiredDocuments />,
    },
    {
      path: routes.dashboard.scholarship,
      element: <Scholarship />,
    },
    {
      path: routes.dashboard.institute,
      element: <Institute />,
    },
    {
      path: routes.dashboard.payments,
      element: <Payments />,
    },
    {
      path: "/payment-status",
      element: <PaymentStatus />,
    },
    {
      path: "/remita-summary",
      element: <RemitaSummary />,
    },
    {
      path: routes.dashboard.viewQualification,
      element: <Qualification />,
    },
    {
      path: routes.dashboard.utmeResult,
      element: <UtmeResult />,
    },
    {
      path: routes.dashboard.dashboard,
      element: <Dashboard />,
    },
    {
      path: routes.dashboard.viewQualification,
      element: <ViewQualification />,
    },
    {
      path: routes.dashboard.viewWorkHistory,
      element: <ViewWorkHistory />,
    },
    {
      path: routes.dashboard.viewInstitute,
      element: <ViewInstitute />,
    },
    {
      path: routes.dashboard.paymentReceipt,
      element: <PaymentReceipt />,
    },
    {
      path: routes.dashboard.applicationStatus,
      element: <ApplicationStatus />,
    },
    {
      path: routes.dashboard.applicationForm,
      element: <ApplicationForm />,
    },
    {
      path: routes.dashboard.admissionStatus,
      element: <AdmissionStatus />,
    },
    {
      path: routes.dashboard.changePassword,
      element: <ChangePassword />,
    },
  ];

  return (
    <Routes>
      <Route element={<ClientLayout />}>
        {mainRoutes.map((item) => (
          <Route key={item.path} path={item.path} element={item.element} />
        ))}
      </Route>

      <Route element={<DashboardLayout />}>
        {dashboardRoutes.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<ProtectedRoute>{item.element}</ProtectedRoute>}
          />
        ))}
      </Route>

      <Route element={<AuthLayout />}>
        {authRoute.map((item) => (
          <Route key={item.path} path={item.path} element={item.element} />
        ))}
      </Route>
      <Route path={routes.onboarding} element={<Onboarding />} />
      <Route path={routes.fileUpload.referenceUpload} element={<ReferenceUpload />} />
    </Routes>
  );
}

export default App;
